import React from "react";
import { get } from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { change, Field } from "redux-form";
import { FormInput, Select } from "MODULES/shared/components/Forms";
import countries from "LIB/countries";
import regions from "LIB/regions";
import { states } from "LIB/states";
import {
  CITY,
  COUNTRY,
  LINE1,
  LINE2,
  POSTAL_CODE,
  REGION,
  PHONE
} from "APP_ROOT/constants";

const countryOptions = countries.map(c => ({ value: c.code, text: c.name }));
const regionOptions = regions.map(c => ({ value: c.name, text: c.name }));

const renderStateField = (country, path, stateProvinceRequired, disabled) =>
  country === "US" ? (
    <Field
      name={`${path}.state`}
      component={Select}
      options={states}
      label="State/Province"
      required={stateProvinceRequired}
      disabled={disabled}
    />
  ) : (
    <Field
      name={`${path}.state`}
      component={FormInput}
      label="State/Province"
      required={stateProvinceRequired}
      disabled={disabled}
    />
  );

export class AddressFields extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (
      !this.props.resetState &&
      this.props.country &&
      this.props.resetStateField &&
      nextProps.country !== this.props.country
    ) {
      this.props.resetStateField();
    }
    if (
      this.props.setFOB &&
      (nextProps.city !== this.props.city ||
        nextProps.province !== this.props.province ||
        nextProps.country !== this.props.country)
    ) {
      this.props.setFOB(
        [nextProps.city, nextProps.province, nextProps.country].join("-")
      );
    }
  }

  onChangeCountry = (_, country) => {
    const { path, setFieldValue, showRegion } = this.props;

    if (country && setFieldValue && showRegion) {
      setFieldValue(
        [path, REGION].filter(f => f).join("."),
        get(countries.find(c => c.code === country), REGION)
      );
    }
  };

  render() {
    const {
      path,
      country,
      addCompanyName,
      showCareOf = true,
      showRegion,
      stateProvinceRequired = false,
      disabled
    } = this.props;
    return (
      <div>
        {addCompanyName && (
          <div className="row row-col-gutters-half">
            <div className="col-md-12">
              <Field
                name={`${path}.company_name`}
                component={FormInput}
                label="Company Name"
                disabled={disabled}
              />
            </div>
          </div>
        )}
        <div className="row row-col-gutters-half">
          <div className="col-md-6">
            <Field
              name={`${path}.${COUNTRY}`}
              component={Select}
              label="Country"
              options={countryOptions}
              disabled={disabled}
              onChange={this.onChangeCountry}
              required
            />
          </div>
          {showRegion && (
            <div className="col-md-6">
              <Field
                name={`${path}.${REGION}`}
                component={Select}
                label="Region"
                options={regionOptions}
                disabled={disabled}
              />
            </div>
          )}
        </div>
        {showCareOf && (
          <div className="row row-col-gutters-half">
            <div className="col-md-6">
              <Field
                name={`${path}.care_of`}
                component={FormInput}
                label="C/O"
                disabled={disabled}
              />
            </div>
          </div>
        )}
        <div className="row row-col-gutters-half">
          <div className="col-md-6">
            <Field
              name={`${path}.${LINE1}`}
              component={FormInput}
              label="Address Line 1"
              disabled={disabled}
              required
            />
          </div>
          <div className="col-md-6">
            <Field
              name={`${path}.${LINE2}`}
              component={FormInput}
              label="Address Line 2"
              disabled={disabled}
            />
          </div>
        </div>
        <div className="row row-col-gutters-half">
          <div className="col-md-5">
            <Field
              name={`${path}.${CITY}`}
              component={FormInput}
              label="City"
              disabled={disabled}
              required
            />
          </div>
          <div className="col-md-4">
            {renderStateField(country, path, stateProvinceRequired, disabled)}
          </div>
          <div className="col-md-3">
            <Field
              name={`${path}.${POSTAL_CODE}`}
              component={FormInput}
              label="Zip/Postal Code"
              disabled={disabled}
              required
            />
          </div>
        </div>
        <div className="row row-col-gutters-half">
          <div className="col-md-5">
            <Field
              name={`${path}.${PHONE}`}
              component={FormInput}
              label="phone"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(undefined, (dispatch, ownProps) => ({
  resetStateField: () =>
    dispatch(change(ownProps.formName, `${ownProps.path}.state`, "")),
  setFieldValue: (field, value) =>
    dispatch(change(ownProps.formName, field, value))
}))(AddressFields);

AddressFields.propTypes = {
  path: PropTypes.string.isRequired,
  country: PropTypes.string,
  showRegion: PropTypes.bool,
  resetState: PropTypes.bool,
  province: PropTypes.string,
  city: PropTypes.string,
  addCompanyName: PropTypes.bool,
  resetStateField: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFOB: PropTypes.func,
  showCareOf: PropTypes.bool.isRequired,
  stateProvinceRequired: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/AddressFields.jsx